export class ResetOrganisationGroupsList {
  public static readonly type =
    '[Organisation/Group/List] ResetOrganisationGroupsList';
}
